window.vm2log = (...val) => console.log('  vm2log:app =>', ...val) ?? val[0];
